import getFromCdn from '@anm/helpers/getFromCdn';
import { media, Arrow } from '@anm/styles/helpers';
import styled from 'styled-components';

import DropdownWrapper, { MobileBackdrop } from '../Dropdown/Wrapper';

const dropDownBreadcrumbWrapperResponsive = media.tablet`
    padding-left: 0;
`;

export const BreadcrumbsContainer = styled.div<{ maxWidth?: number | null }>`
  display: flex;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'initial')};
`;

const DropDownBreadcrumbWrapper = styled.div<{ isArrow: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  ${DropdownWrapper} {
    &:after {
      position: absolute;
      background: url(${({ isArrow }) => (isArrow ? getFromCdn('images/dashboard/arrow-down-triangle.svg') : '')})
        no-repeat center transparent;
      margin: 2px 0 0;
      pointer-events: none;
    }
    &:hover {
      &:after {
        transform: none;
      }
      & + ${MobileBackdrop} {
        display: block;
      }
    }
  }
  ${dropDownBreadcrumbWrapperResponsive};
`;

export const ArrowWrapper = styled(Arrow)`
  margin-left: 17px;
`;

export default DropDownBreadcrumbWrapper;
